import React, {useState, useEffect} from 'react';
import {NavLink, useLocation} from 'react-router-dom';
import styles from './NavigationColumn.module.css';
import NavigationButton from './NavigationButton';
import {ReactComponent as AppLogo} from '../../../../shared/project-info/svgs-web/AppLogo.svg';
import {
  logAccessFeed,
  logAccessEvents,
  logAccessMyProfile,
} from '../../../../shared/models/Analytics';
import ApiInfo from '../ApiInfo';
import QuestionIcon from '../svgs/QuestionIcon';
import {projectConfig} from '../../../../shared/project-info/projectConfig';
import {pickProjectConfigValue} from '../../../../shared/utils/ProjectConfigPicker';
import {tenantProjectInfo} from '../../../../shared/models/TenantProjectInfo';

export default function NavigationColumn() {
  const location = useLocation();
  const [isConfigLoaded, setIsConfigLoaded] = useState(
    tenantProjectInfo.isLoaded,
  );

  useEffect(() => {
    if (tenantProjectInfo.isLoaded) {
      setIsConfigLoaded(true);
    } else {
      tenantProjectInfo.init().then(() => {
        setIsConfigLoaded(true);
      });
    }
  }, [tenantProjectInfo.isLoaded]);

  function isNavBarDisplayed(location) {
    const {pathname} = location;
    const allowedPaths = [
      '/feed',
      '/groups',
      '/events',
      '/challenges',
      '/profile',
      '/notifications',
      // '/login',
      // '/registration',
    ];
    for (const allowedPath of allowedPaths) {
      if (pathname.startsWith(allowedPath)) {
        return true;
      }
    }
    return false;
  }
  const showNavBar = isNavBarDisplayed(location);

  // Show loading state while config is loading
  if (!isConfigLoaded) {
    return (
      <div className={styles.container}>
        <div>Loading...</div>
      </div>
    );
  }

  return (
    <div className={showNavBar ? styles.container : styles.none}>
      <div className={styles.navLinkContainer}>
        <div className={styles.navLogo}>
          {tenantProjectInfo.logoUrl ? <img src={tenantProjectInfo.logoUrl} alt="Logo" className={styles.navLogo} /> : <AppLogo className={styles.navLogo} />}
        </div>
        {/* <NavLink to="/">
          <NavigationButton label={'Home'} url={'/'} />
        </NavLink> */}
        <NavLink onClick={logAccessFeed} to="/feed">
          <NavigationButton label={'Feed'} url={'/feed'} />
        </NavLink>
        {/* onClick={logAccessGroups} */}
        {pickProjectConfigValue('hasGroups') && (
          <NavLink to="/groups">
            <NavigationButton label={'Groups'} url={'/groups'} />
          </NavLink>
        )}
        <NavLink onClick={logAccessEvents} to="/events">
          <NavigationButton label={'Events'} url={'/events'} />
        </NavLink>
        {pickProjectConfigValue('hasChallenges') && (
          <NavLink
            // onClick={logAccessChallenges}
            to="/challenges">
            <NavigationButton label={'Challenges'} url={'/challenges'} />
          </NavLink>
        )}

        <NavLink onClick={logAccessMyProfile} to="/profile">
          <NavigationButton label={'Profile'} url={'/profile'} exact />
        </NavLink>
      </div>

      <div className={styles.settingsContainer}>
        {projectConfig.userSupportLink && (
          <a
            className={`link ${styles.getHelp}`}
            href={projectConfig.userSupportLink}
            target="_blank"
            rel="noreferrer noopener">
            <QuestionIcon width={16} height={16} />
            Get Help
          </a>
        )}
        <div>{pickProjectConfigValue('orgName')}</div>
        <div>
          <a
            className="link"
            href={projectConfig.privacyPolicy}
            target="_blank"
            rel="noreferrer noopener">
            Privacy Policy
          </a>
        </div>
        <div>
          <a
            className="link"
            href={
              projectConfig.communityGuidelines
                ? projectConfig.communityGuidelines
                : projectConfig.termsConditions
            }
            target="_blank"
            rel="noreferrer noopener">
            {projectConfig.communityGuidelines
              ? 'Community Guidelines'
              : 'Terms & Conditions'}
          </a>
        </div>
        <div>
          <p style={{fontSize: 12}}>Version: {projectConfig.version}</p>
        </div>
        <ApiInfo />
      </div>
    </div>
  );
}
